import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1, { useContext } from 'react';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import Logo$1 from '../../basics/Logo/Logo.js';
import StyledNavigation from './Navigation.style.js';
import { NavigationContext } from '../../contexts/NavigationProvider/NavigationProvider.js';

const Navigation = ({
  className,
  homeLink,
  mainLinks,
  subLinks
}) => {
  const {
    isOpen,
    toggleNavigation,
    listRef
  } = useContext(NavigationContext);
  return /*#__PURE__*/React$1.createElement(StyledNavigation, {
    className: className,
    isOpen: isOpen
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__curtain"
  }), /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    onClick: () => toggleNavigation()
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "span",
    transform: "uppercase"
  }, isOpen ? 'Close' : 'Menu')), /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__wrapper"
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, homeLink, {
    "aria-label": "Home",
    className: "navigation__logo"
  }), /*#__PURE__*/React$1.createElement(Logo$1, {
    inline: true
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__list",
    ref: listRef
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, homeLink, {
    "aria-label": "Home",
    className: "navigation__mobile-logo"
  }), /*#__PURE__*/React$1.createElement(Logo$1, {
    size: "large"
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "navigation__list-wrapper"
  }, /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__mainlist"
  }, mainLinks.map(link => link && /*#__PURE__*/React$1.createElement("li", {
    key: link.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    icon: "default",
    transform: "uppercase",
    className: link.isActive ? 'is-active' : ''
  }, link), /*#__PURE__*/React$1.createElement("span", null, link.label)), link.subLinks && link.subLinks.length > 0 && /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__mainlist-sub"
  }, /*#__PURE__*/React$1.createElement("li", null, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    icon: "default"
  }, link, {
    transform: "uppercase",
    tabindex: "-1"
  }), /*#__PURE__*/React$1.createElement("span", null, link.label))), link.subLinks.map(sublink => sublink && /*#__PURE__*/React$1.createElement("li", {
    key: sublink.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    transform: "uppercase",
    icon: "default",
    className: sublink.isActive ? 'is-active' : ''
  }, sublink), /*#__PURE__*/React$1.createElement("span", null, sublink.label)))))))), subLinks && subLinks.length > 0 && /*#__PURE__*/React$1.createElement("ul", {
    className: "navigation__sublist"
  }, subLinks.map(link => link && /*#__PURE__*/React$1.createElement("li", {
    key: link.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    transform: "uppercase",
    className: link.isActive ? 'is-active' : ''
  }, link), /*#__PURE__*/React$1.createElement("span", null, link.label)))))))));
};

Navigation.propTypes = {
  className: PropTypes$1.string,
  homeLink: PropTypes$1.shape().isRequired,
  mainLinks: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired,
  subLinks: PropTypes$1.arrayOf(PropTypes$1.shape())
};
Navigation.defaultProps = {
  subLinks: null,
  className: ''
};

export default Navigation;
